import styles from './RootPageContainer.module.scss';
import { useTranslation } from 'react-i18next';
import logo from '@casops/assets/wabtec-logo-white.svg';
import { ReactNode } from 'react';

export function RootPageContainer({ children }: { children?: ReactNode }) {
  const { t } = useTranslation();

  return (
    <article className={styles.pageContainer}>
      <div className={styles.contentContainer}>
        <header className={styles.header}>
          <img className={styles.logo} src={logo} alt={t('WabtecLogo')} />
        </header>
        <div className={styles.content}>{children}</div>
      </div>
    </article>
  );
}

export default RootPageContainer;
